namespace TabAurous.OMS {
    export interface AccountLedgerForm {
        LedgerId: Serenity.IntegerEditor;
        PartyType: Serenity.StringEditor;
        PartyCode: Serenity.StringEditor;
        AccountGroupId: Serenity.LookupEditor;
        LedgerName: Serenity.StringEditor;
        MailingName: Serenity.StringEditor;
        DefaultTDSType: Serenity.LookupEditor;
        IsDisabled: Serenity.BooleanEditor;
        BillbyBill: Serenity.BooleanEditor;
        AccountNo: Serenity.StringEditor;
        IFSCCode: Serenity.StringEditor;
        MICRCode: Serenity.StringEditor;
        Swift: Serenity.StringEditor;
    }

    export class AccountLedgerForm extends Serenity.PrefixedContext {
        static formKey = 'OMS.AccountLedger';
        private static init: boolean;

        constructor(prefix: string) {
            super(prefix);

            if (!AccountLedgerForm.init)  {
                AccountLedgerForm.init = true;

                var s = Serenity;
                var w0 = s.IntegerEditor;
                var w1 = s.StringEditor;
                var w2 = s.LookupEditor;
                var w3 = s.BooleanEditor;

                Q.initFormType(AccountLedgerForm, [
                    'LedgerId', w0,
                    'PartyType', w1,
                    'PartyCode', w1,
                    'AccountGroupId', w2,
                    'LedgerName', w1,
                    'MailingName', w1,
                    'DefaultTDSType', w2,
                    'IsDisabled', w3,
                    'BillbyBill', w3,
                    'AccountNo', w1,
                    'IFSCCode', w1,
                    'MICRCode', w1,
                    'Swift', w1
                ]);
            }
        }
    }
}
